import Stage from 'components/Designer/Stage'
import * as THREE from 'three'

const setDefaults = () => {
  Stage.orbitCtrl.enableDamping = true
  Stage.orbitCtrl.dampingFactor = 1
  Stage.orbitCtrl.enableKeys = true
  Stage.orbitCtrl.keys = {
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    BOTTOM: 40,
  }
  Stage.orbitCtrl.touches = {
    ONE: THREE.TOUCH.ROTATE,
    TWO: THREE.TOUCH.DOLLY_PAN,
  }
  Stage.orbitCtrl.screenSpacePanning = true
  Stage.orbitCtrl.target = new THREE.Vector3(24, 34, -34)
  /* Stage.orbitCtrl.minAzimuthAngle = (-Math.PI * 2) / 3
   * Stage.orbitCtrl.maxAzimuthAngle = (Math.PI * 2) / 3 */
  /* Stage.orbitCtrl.minPolarAngle = -Math.PI / 2
   * Stage.orbitCtrl.maxPolarAngle = Math.PI / 1.9 */
  /* Stage.orbitCtrl.maxDistance = 8 */
  Stage.orbitCtrl.minDistance = 2
  Stage.orbitCtrl.update()
}

export default setDefaults
